<script>
import Popper from 'vue3-popper'
import CommentCreator from '@/components/TasksCalendar/Comments/Driver/CommentCreator.vue'
import DriverCellColorPicker from '@/components/Partials/ColorPickers/DriverCellColorPicker.vue'
import emitter from '@/modules/events/emitter'
import eventKinds from '@/modules/events/eventKinds'
import moment from 'moment-timezone'
import Swal from 'sweetalert2'
import { $axios } from '@/modules/http/axios'

export default {
  name: 'DriverCell',
  components: { DriverCellColorPicker, CommentCreator, Popper },
  props: ['givenDriver'],
  data () {
    return {
      driver: this.givenDriver,
      vehicle: null
    }
  },
  created () {
    emitter.on(eventKinds.driverCommentAdded, this.reFetchDriver)
    emitter.on(eventKinds.driverCommentDeleted, this.reFetchDriver)
    emitter.on(eventKinds.driverColorChanged, this.reFetchDriver)
  },
  methods: {
    launchDriverCommentModal (driver) {
      emitter.emit(eventKinds.driverCommentModalRequested, { driver: driver })
    },
    async fetchVehicle () {
      this.vehicle = (await $axios.get('Vehicle')).data.find(v => {
        const drivers = v.drivers.map(d => d.id)
        return drivers.includes(this.driver.id)
      })
    },
    async detachDriver () {
      const postData = { driverIds: [this.driver.id] }
      let selectedArrivalDate = moment().tz('Europe/Warsaw').format('YYYY-MM-DDTHH:mm')
      let selectedPlannedDepartureDate = moment().add(6, 'days').tz('Europe/Warsaw').format('YYYY-MM-DDTHH:mm')

      const arrivalDialogResult = await Swal.fire({
        title: 'Czy przypisać datę zjazdu automatycznie?',
        icon: 'question',
        showCancelButton: true,
        cancelButtonText: 'Nie',
        showConfirmButton: true,
        confirmButtonText: 'Tak'
      })

      if (!arrivalDialogResult.isConfirmed) {
        await Swal.fire({
          title: 'Proszę określić datę zjazdu',
          icon: 'question',
          showCancelButton: true,
          cancelButtonText: 'Anuluj',
          showConfirmButton: true,
          confirmButtonText: 'Przejdź dalej',
          html: `
            <div>Data zjazdu:</div>
            <input class="form-control" id="arrival-date" type="datetime-local" value="${moment().tz('Europe/Warsaw').format('YYYY-MM-DDTHH:mm')}" required>
          `,
          preConfirm: () => {
            return new Promise(resolve => {
              const arrivalDate = document.getElementById('arrival-date').value

              if (arrivalDate === '') {
                Swal.fire('Proszę uzupełnić datę zjazdu', '', 'warning')
              } else {
                resolve(arrivalDate)
              }
            }).then(result => {
              selectedArrivalDate = result
            })
          }
        })
      }

      const departureDialogResult = await Swal.fire({
        title: 'Proszę określić datę wyjazdu',
        icon: 'question',
        showCancelButton: true,
        cancelButtonText: 'Anuluj',
        showConfirmButton: true,
        confirmButtonText: 'Zatwierdź',
        html: `
          <div>Data Wyjazdu:</div>
          <input class="form-control" id="planned-departure-date" type="datetime-local" value="${moment(selectedArrivalDate).add(6, 'days').tz('Europe/Warsaw').format('YYYY-MM-DDTHH:mm')}" required>
        `,
        preConfirm: () => {
          return new Promise(resolve => {
            const plannedDepartureDate = document.getElementById('planned-departure-date').value

            if (plannedDepartureDate === '') {
              Swal.fire('Proszę uzupełnić datę wyjazdu', '', 'warning')
            } else {
              resolve(plannedDepartureDate)
            }
          }).then(result => {
            selectedPlannedDepartureDate = result
          })
        }
      })

      postData.arrivalDate = selectedArrivalDate
      postData.plannedDepartureDate = selectedPlannedDepartureDate

      if (departureDialogResult.isConfirmed) {
        $axios.post(`Vehicle/Vehicle/${this.vehicle.id}/Driver/Unassign`, postData).then(() => {
          Swal.fire(`Odpięto kierowcę ${this.driver.firstName} ${this.driver.surname} od ciągnika ${this.vehicle.plateNumber}.`, '', 'success')
          emitter.emit('vehicleChanged')
        }).catch(e => {
          Swal.fire(
            `Nie udało się odpiąć kierowcy ${this.driver.firstName} ${this.driver.surname} od ciągnika "${this.vehicle.plateNumber}"`,
            `System nie był w stanie wykonać żądanej operacji <br> <span class="fw-bold">Kod błędu: ${e.response?.status}</span>`,
            'error'
          )
        })
      } else {
        await Swal.fire('Anulowano odpięcie kierowcy', 'Operacja została anulowana', 'info')
      }
    },
    async reFetchDriver () {
      this.driver = (await $axios.get(`Driver/${this.driver.id}`)).data
    }
  }
}
</script>

<template>
  <div
    class="fw-bolder user-select-none rounded px-2 py-1"
    :style="`background-color: ${driver.backgroundColor ?? '#ffffff'}; color: ${driver.textColor ?? '#000000'};`">
    <div class="d-flex justify-content-between">
      <div class="text-sm-secondary">
        <Popper placement="right" @open:popper="fetchVehicle">
        <span role="button">
          {{ driver.firstName }} {{ driver.surname }}
        </span>
          <template #content>
            <button v-if="vehicle" class="btn btn-danger" @click="detachDriver">
              Odepnij kierowcę
            </button>
            <span v-else>Brak dostępnych akcji</span>
          </template>
        </Popper>
      </div>
      <div class="text-xl">
        <Popper placement="right">
        <span class="text-darker px-1" role="button">
          <i class="fa-solid fa-ellipsis-vertical"></i>
        </span>
          <template #content>
            <CommentCreator :driver-id="driver.id"/>
            <DriverCellColorPicker :driver="driver"/>
          </template>
        </Popper>
      </div>
    </div>
    <div>
      <div
        v-show="driver.comments.length"
        class="fw-bolder notebook-btn text-xs"
        data-bs-toggle="modal"
        data-bs-target="#driverCommentModal"
        @click="launchDriverCommentModal(driver)"
        role="button">
        NOTES {{ driver.comments.length }}
      </div>
    </div>
  </div>
</template>

<style scoped>
.text-xs {
  font-size: .5rem;
}
.text-sm-secondary {
  font-size: .6rem;
}
</style>
